import 'bootstrap';
import('admin.lte');

import '../../../../public/static/plugins/bootstrap/assets/stylesheets/bootstrap.scss';
import '../scss/app.scss';

import WarehouseAutocompleteForm from "./components/WarehouseAutocompleteForm";
import Counters from "./components/Counters";
import OrderDetail from "./components/OrderDetail";
import DiscountHandlerManager from "./components/DiscountHandlerManager";
import TrackingManager from "./components/TrackingManager";
import PaymentLinkSender from "./components/PaymentLinkSender";
import BonusRulesHelper from "./components/BonusRulesHelper";
import LatinTranslater from "./components/LatinTranslater";
import CharactersCounter from "./components/CharactersCounter";
import TabsManager from "./components/TabsManager";
import DatePickerManager from "./components/DatePickerManager";
import RelatedProducts from "./components/RelatedProducts";
import VariantsTable from "./components/VariantsTable";
import PermissionsChecker from "./components/PermissionsChecker";
import ReviewsTransfer from "./components/ReviewsTransfer";
import ReviewAnswers from "./components/ReviewAnswers";
import ReviewsTopFixed from "./components/ReviewsTopFixed";
import Reviews from "./components/Reviews";
import ScrollToTop from "./components/ScrollToTop.js";
import CollectionsSearch from "./components/CollectionsSearch.js";
import PrimaryRoleSelector from "./components/PrimaryRoleSelector.js";
import ClaimFormBuilder from "./components/ClaimFormBuilder.js";
import CheckboxToRadio from "./components/CheckboxToRadio.js";
import Claims from "./components/Claims.js";
import SendTestMail from "./components/SendTestMail.js";
import BannerVariants from "./components/BannerVariants.js";
import ChartJs from "./components/Chartjs";
import Carousels from "./components/Carousels";
import ChatManager from "./components/ChatManager";
import CompensationItems from "./components/CompensationItems";
import Compensation from "./components/Compensation";
import AdminLocaleSwitcher from "./components/AdminLocaleSwitcher";
import CurrencyConverter from "./components/CurrencyConverter";
import SplitOrder from "./components/SplitOrder";
import AllCheckBoxesSelector from "./components/AllCheckBoxesSelector";
import Domain from "./components/Domain";
import OrderNotPaidMailSender from "./components/OrderNotPaidMailSender";
import CollectionSelector from "./components/CollectionSelector";
import DomainLocationSelector from "./components/DomainLocationSelector";
import QuizManager from "./components/QuizManager";
import ChangeArticleModeration from "./components/ChangeArticleModeration";

$(document).ready(function () {
    /*  CSRF TOKEN
     ---------------------------------- */
    // ADDED TO AJAX CSRF TOKEN AUTOMATICLY
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    DiscountHandlerManager.init();
    (new SplitOrder()).init();
    (new TrackingManager()).init();
    CharactersCounter.init();
    TabsManager.init();
    RelatedProducts.init();
    VariantsTable.init();
    DatePickerManager.init();
    ScrollToTop.init();
    ClaimFormBuilder.init();
    AdminLocaleSwitcher.init();
    DomainLocationSelector.init();
    (new ChangeArticleModeration()).init();

    if ($('#domains_form').length) {
        Domain.init();
    }

    if($('#send_payment_link_btn').length) {
        (new PaymentLinkSender()).init();
    }

    if($('#send_not_paid_email_btn').length) {
        (new OrderNotPaidMailSender()).init();
    }

    if ($('#order_admin_form').length) {
        OrderDetail.init();
    }

    if ($('.menu-counter').length) {
        Counters.init();
    }

    if ($('#warehouse_autocomplete_form').length) {
        WarehouseAutocompleteForm.init();
    }

    if ($('#bonus_rule_type').length) {
        BonusRulesHelper.init();
    }

    if ($('#translate_button').length || $('.translate_button').length) {
        LatinTranslater.init();
    }

    if ($('.permissions_container').length > 0) {
        PermissionsChecker.init();
    }

    if ($('.js-transfer').length) {
        ReviewsTransfer.init();
    }

    if ($('#get_answer_link').length) {
        ReviewAnswers.init();
    }

    if ($('.reviews-form')) {
        ReviewsTopFixed.init();
    }

    if ($('.reviews-form')) {
        Reviews.init();
    }

    if ($('.claim-form')) {
        Claims.init();
    }

    if ($('#search-filter').length || $('.search-filter').length) {
        CollectionsSearch.init();
    }

    if ($('#primary-role').length) {
        PrimaryRoleSelector.init();
    }

    if ($('#email-patterns-container').length) {
        SendTestMail.init();
    }

    if ($('.admin-banner-form').length) {
        BannerVariants.init();
    }

    if ($('.has-chart-js').length) {
        ChartJs.init();
    }

    if ($('#carousels-panel').length) {
        Carousels.init();
    }

    if ($('#chat-form').length) {
        ChatManager.init();
    }

    if ($('#compensation-items-panel').length) {
        Compensation.init();
        CompensationItems.init();
    }

    if($('#currency_converter').length) {
        (new CurrencyConverter()).init();
    }
    
    if($('.js-checkbox-to-radio').length) {
        (new CheckboxToRadio()).init();
    }

    if($('#select_all_checkboxes').length || $('.select_all_checkboxes').length) {
        (new AllCheckBoxesSelector()).init();
    }

    if ($('#collection_container').length && $('#use_for_collection').length) {
        CollectionSelector.init();
    }

    if ($('#quiz-form').length) {
        QuizManager.init();
    }

    import('./components/ImageInputAdminManager.js').then((ImageInputAdminManager) => {
        (new ImageInputAdminManager.default()).init();
    })


    /* SELECT2 PLUGIN
     -------------------------------- */
    import('select2').then(() => {
        $(".select2").select2({
            width: '100%'
        });
    });

    $(".extra-bonuses-table h4").click(function() {
        $('.extra-bonuses-table').find('tbody').toggle("slow");
    });
});
